// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__f8x5s","location":"Header_location__2rSBi"};